import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import tr from "./locales/tr.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import ru from "./locales/ru.json";
import es from "./locales/es.json";

i18n.use(initReactI18next).init({
  resources: { tr: { translation: tr }, en: { translation: en }, de: { translation: de }, fr: { translation: fr }, ru: { translation: ru }, es: { translation: es } },
  lng: localStorage.getItem("remil-lang") || "tr",
  fallbackLng: "tr",
  interpolation: { escapeValue: false },
});

export default i18n;